import { Box, Button, Stack, styled, useTheme } from "@mui/material";
import React from "react";
import { LAYOUT_TYPES } from "../../../constants";
import { tokens } from "../../../theme";
import Header from "./components/Header";

const StyledButton = styled(Button)(
  ({ theme, colors, bgColor, fontColor, fontW, bgOnHover }) => ({
    backgroundColor: bgColor,
    color: fontColor,
    fontSize: "14px",
    fontWeight: fontW,
    width: "187px",
    height: "40px",
    borderColor: colors.primary[500],
    borderRadius: "7px",
    "&:hover": {
      backgroundColor: bgOnHover,
      borderColor: colors.primary[500],
      color: "#ffffff",
    },
  })
);

const ProfileLayout = ({
  FilterBox,
  layoutType = "myNfts",
  children,
  currView,
  setCurrView,
  setSearchShow,
  setSearchVar,
  collectionCount = true,
  nftCount = true,
  name,
  address,
  coverImage,
  profileImage,
  scholarId,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <Header
        layoutType={layoutType}
        collectionCount={collectionCount}
        nftCount={nftCount}
        name={name || false}
        address={address || false}
        profileImage={profileImage || false}
        coverImage={coverImage || false}
        scholarId={scholarId || false}
      />

      {layoutType === LAYOUT_TYPES.GUILD_HUB && (
        <Stack
          direction={"row"}
          justifyContent="flex-start"
          gap="10px"
          sx={{ marginBottom: "10px", marginLeft: "25px" }}
        >
          <StyledButton
            onClick={() => {
              setCurrView("scholar-details");
              // setSearchShow(false);
              // setSearchVar("");
            }}
            variant="outlined"
            colors={colors}
            bgColor={
              currView === "scholar-details"
                ? colors.primary[500]
                : colors.whiteAccent[900]
            }
            fontColor={
              currView === "scholar-details"
                ? colors.whiteAccent[900]
                : colors.primary[500]
            }
            fontW={400}
            bgOnHover={colors.primary[600]}
          >
            Scholar Details
          </StyledButton>
          <StyledButton
            variant="outlined"
            colors={colors}
            bgColor={
              currView === "asset-details"
                ? colors.primary[500]
                : colors.whiteAccent[900]
            }
            fontColor={
              currView === "asset-details"
                ? colors.whiteAccent[900]
                : colors.primary[500]
            }
            fontW={500}
            bgOnHover={colors.primary[600]}
            onClick={() => {
              setCurrView("asset-details");
              // setSearchShow(false);
              // setSearchVar("");
            }}
          >
            Assets Details
          </StyledButton>
        </Stack>
      )}

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          height: "100%",
          borderTop: "2px solid #E8ECF5",
        }}
      >
        {FilterBox && (
          <Box flex={1}>
            <FilterBox />
          </Box>
        )}
        <Box flex={18}>{children}</Box>
      </Box>
    </Box>
  );
};

export default ProfileLayout;
